import React from 'react';

import Table from 'components/Table';
import ModalWorkoutTemplatePreview from 'pages/private/owner/Workouts/Library/components/WorkoutLibrary/WorkoutTemplates/components/ModalWorkoutTemplatePreview';

import { useWorkoutsColumns } from './columns/useWorkoutsColumns';
import ModalWorkoutDelete from './ModalWorkoutDelete';
import type { WorkoutTableContainerProps } from './types';
import { useWorkoutTable } from './useWorkoutTable';

const WorkoutTableContainer = (props: WorkoutTableContainerProps): JSX.Element => {
  const { tableData, columnsInput, tableProps, deleteModal, previewModal } = useWorkoutTable(props);

  const columns = useWorkoutsColumns(columnsInput);

  return (
    <>
      <ModalWorkoutDelete
        opened={deleteModal.opened}
        workout={deleteModal.workout}
        handleClose={deleteModal.onClose}
      />
      <ModalWorkoutTemplatePreview
        opened={previewModal.opened}
        template={previewModal.workout}
        handleClose={previewModal.onClose}
        showEditButton={false}
      />
      <Table fillHeight tableData={tableData} columns={columns} {...tableProps} />
    </>
  );
};

export default WorkoutTableContainer;
